import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdministrationFileList } from '../api/src/app/models/REGBP-V1.0.0/responses/administration-file-list.model';
import { RegbpService } from '../api/src/app/services/regbp.service';


@Injectable({
  providedIn: 'root'
})
export class AdministrationFileFacade {
  constructor(public regbpService: RegbpService) {}

  getAdministrationFiles(): Observable<AdministrationFileList> {
    return this.regbpService.getAdministrationFiles();
  }
}
